import { Injectable } from "@angular/core";
import { Notification } from "@models/common.model";
import { Subject } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class NotificationService{
	readonly notify=new Subject<Notification>();

	notifyInfo(text: string){
		this.norify({text, type: 'info'});
	}

	notifyError(text: string){
		this.norify({text, type: 'error'});
	}

	notifySuccess(text: string){
		this.norify({text, type: 'success'});
	}

	norify(notification: Notification){
		this.notify.next(notification);
	}
}